// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
  background-color: var(--surface-dark);
  color: var(--text-on-dark);
  margin-top: 40px;
  padding-top: 20px;
}

.footer-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 32px;
  justify-content: space-between;
  padding: 40px 24px;
}

.footer-tagline {
  max-width: 320px;
  opacity: 0.85;
  margin: 8px 0 0;
  font-size: 0.9rem;
  font-style: italic;
}

.footer-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}

/* Coral clears AAA (7.83) against the ink-deep page surface, so links can
   carry the accent down here — unlike on the lighter contact bar. */
.footer-nav a,
.footer-nav a:visited {
  color: var(--text-accent-on-dark);
}

.footer-nav a:hover {
  color: var(--text-on-dark);
}

.footer-contact {
  opacity: 0.9;
  font-size: 0.9rem;
  margin-top: 12px;
  font-weight: 700;
  & a {
    color: var(--text-accent-on-dark) !important;
  }
}

.footer-bottom {
  text-align: center;
  padding: 14px;
  font-size: 0.8rem;
  border-top: 1px solid var(--border-on-dark);
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;oEACoE;AACpE;;EAEE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB","sourcesContent":[".site-footer {\n  background-color: var(--surface-dark);\n  color: var(--text-on-dark);\n  margin-top: 40px;\n  padding-top: 20px;\n}\n\n.footer-inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 32px;\n  justify-content: space-between;\n  padding: 40px 24px;\n}\n\n.footer-tagline {\n  max-width: 320px;\n  opacity: 0.85;\n  margin: 8px 0 0;\n  font-size: 0.9rem;\n  font-style: italic;\n}\n\n.footer-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n/* Coral clears AAA (7.83) against the ink-deep page surface, so links can\n   carry the accent down here — unlike on the lighter contact bar. */\n.footer-nav a,\n.footer-nav a:visited {\n  color: var(--text-accent-on-dark);\n}\n\n.footer-nav a:hover {\n  color: var(--text-on-dark);\n}\n\n.footer-contact {\n  opacity: 0.9;\n  font-size: 0.9rem;\n  margin-top: 12px;\n  font-weight: 700;\n  & a {\n    color: var(--text-accent-on-dark) !important;\n  }\n}\n\n.footer-bottom {\n  text-align: center;\n  padding: 14px;\n  font-size: 0.8rem;\n  border-top: 1px solid var(--border-on-dark);\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
